import { ua } from './ua';
import { isIos } from './system';

/**
 * 是否为微信浏览器，包括微信个人版和微信企业版
 */
export const isWeChat = /micromessenger/i.test(ua);

/**
 * 是否为微信【企业版】浏览器
 */
export const isWxWork = /micromessenger/i.test(ua) && /wxwork/i.test(ua);

/**
 * 是否为微信【个人版】浏览器
 */
export const isWxChat = /micromessenger/i.test(ua) && !/wxwork/i.test(ua);

/**
 * 业务代码上，企业微信暂不处理，只关注个人微信
 */
export const isWeixinBrowser = isWxChat;

let _isInMiniProgram: boolean;
export function isInMiniProgram(): Promise<boolean> {
    return new Promise((resolve, _reject) => {
        if (typeof _isInMiniProgram !== 'undefined') {
            resolve(_isInMiniProgram);
            return;
        }

        if (!isWeixinBrowser) {
            _isInMiniProgram = false;
            resolve(_isInMiniProgram);
            return;
        }

        // mac上也判断为是iOS
        if (isIos) {
            const wx: any = (window as any).wx; // 暂时用 any
            if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
                wx.miniProgram.getEnv((res: any) => {
                    _isInMiniProgram = res.miniprogram; // true
                    resolve(_isInMiniProgram);
                });
            } else {
                _isInMiniProgram = false;
                resolve(_isInMiniProgram);
            }
        } else {
            _isInMiniProgram = /miniProgram/i.test(navigator.userAgent);
            resolve(_isInMiniProgram);
        }
    });
}

export const isInWechatMp =
    ua.match(/miniProgram/i) || (window as any).__wxjs_environment === 'miniprogram' || ua.match(/wechatdevtools/);

// 是否桌面版小程序
export const isInMpDesktop = !!(ua.match(/miniprogramenv\/mac/i) || ua.match(/miniprogramenv\/windows/i));
